<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="Trash" pageTitle="Trash" />
            <TrashContent />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import TrashContent from '../Trash/TrashContent'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'TrashPage',
    components: {
        MainHeader,
        PageTitle,
        TrashContent,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>